import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import {
  BRAND_CAMPAIGN_STATUS_FILTERS,
  BrandCampaign,
} from "../../../../../shared/models/brandCampaign";

export type BrandCampaignBoxPreviewDialogData = BrandCampaign;
export type BrandCampaignBoxPreviewDialogResult = undefined;

@Component({
  selector: "app-brand-campaign-box-preview-dialog",
  templateUrl: "./brand-campaign-box-preview-dialog.component.html",
  styleUrls: ["./brand-campaign-box-preview-dialog.component.scss"],
})
export class BrandCampaignBoxPreviewDialogComponent {
  public readonly campaign: BrandCampaign;
  public readonly firstCampaignImageFile: string;
  public readonly STATUS_ATTRS = BRAND_CAMPAIGN_STATUS_FILTERS;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: BrandCampaignBoxPreviewDialogData,
  ) {
    this.campaign = data;
    this.firstCampaignImageFile =
      this.campaign.currentDetails &&
      this.campaign.currentDetails.sliders.length > 0
        ? this.campaign.currentDetails.sliders[0].file
        : "/assets/images/draft-generic-image.jpg";
  }
}
